import { client } from '@generated/kaiser/client.gen';
import { getAuthToken } from '@auth/session-storage';
import { config } from '@config';

// Host only — the Kaiser spec's operation paths include the
// `/services/adminprime` base path, so the client baseUrl must not repeat it.
export const KAISER_BASE_URL = config.kaiserBaseUrl;

client.setConfig({
    baseUrl: KAISER_BASE_URL,
    auth: () => getAuthToken() ?? '',
});

export { client as kaiserClient };
